import styled from "styled-components";

export const TopbarWrapper = styled.div`
  width: 100%;
  background-color: ${props => props.fundo || "#f3f3f4"};
  color: ${props => props.texto || "#333"};
  position: relative;
`;

export const InnerContent = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  height: 47px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 0 16px;
  /* Ancora o CenterBlock, que e posicionado em relacao a barra inteira. */
  position: relative;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const LeftBlock = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0;

  /* As regras de img/svg e de .no-selected button sairam junto com o icone de loja e o
     botao "Encontre a farmacia mais perto de voce", que eram a segunda entrada de
     localizacao na barra. */

  .selected {
    display: flex;
    align-items: center;

    span {
      font-weight: 700;
      cursor: pointer;
      font-size: 14px;
      margin-top: 3px;
    }
  }

  @media (max-width: 768px) {
    .selected span {
      display: none;
    }
  }
`;

export const CenterBlock = styled.div`
  /* Centrada em relacao a BARRA INTEIRA, nao ao espaco que sobra entre o bloco esquerdo e
     os botoes da direita. O seletor de local de entrega tem largura minima e cresce com o
     conteudo; com o CenterBlock no fluxo, cada mudanca de estado do seletor deslocava a
     mensagem. Fora do fluxo, ela fica parada. */
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  transform: translateX(-50%);
  max-width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  overflow: hidden;
  min-width: 0;
  pointer-events: auto;
  background-color: ${props => props.fundo || "transparent"};
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: opacity 300ms ease;

  a, > span {
    color: inherit;
    text-decoration: none;
    font-size: 1.4rem;
    font-weight: 500;
    white-space: nowrap;
  }

  .marquee-text {
    display: inline-block;
    white-space: nowrap;
    animation: marqueeScroll 8s linear infinite;
  }

  @keyframes marqueeScroll {
    0%   { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
  }
`;

export const RightBlock = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 0;
  padding-left: 8px;
`;

export const BotaoPill = styled.a`
  background-color: ${props => props.fundo || "transparent"};
  color: ${props => props.texto || "inherit"} !important;
  /* border: 1.5px solid ${props => props.texto || "currentColor"}; */
  border-radius: 50px;
  padding: 5px 14px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }

  @media (max-width: 768px) {
    display: ${props => props.showOnMobile ? 'inline-flex' : 'none'};
  }
`;

export const DesktopChevronWrapper = styled.div`
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ChevronButton = styled.button`
  background: transparent;
  border: 1.5px solid currentColor;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  color: inherit;
  cursor: pointer;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const MobileChevronButton = styled.button`
  display: none;
  background: transparent;
  border: 1.5px solid currentColor;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  color: inherit;
  cursor: pointer;
  font-size: 1.4rem;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const ChevronDropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 200;
  min-width: 160px;
  overflow: hidden;

  a {
    display: block;
    padding: 10px 16px;
    color: #333;
    text-decoration: none;
    font-size: 1.4rem;

    &:hover {
      background: #f5f5f5;
    }
  }
`;

export const MobileOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3000;
`;

export const MobilePopup = styled.div`
  position: fixed;
  top: 47px;
  right: 0;
  left: 0;
  background: #fff;
  z-index: 3001;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;

  > a {
    display: inline-flex;
    width: 100%;
    min-height: 36px;
    padding: 8px 14px;
    font-size: 1.4rem;
    justify-content: flex-start;

    &:hover {
      opacity: 0.85;
    }
  }

  @media (max-width: 395px) {
    flex-direction: column;
  }
`;
